import { gql } from "@apollo/client";

const GET_ENGAGEMENT_DETAILS = gql`
  query GetEngagementDetails($onboarding_token: String!) {
    engagementDetails: engagement_details(onboarding_token: $onboarding_token) {
      value
    }
  }
`;

export default GET_ENGAGEMENT_DETAILS;
